import { render, staticRenderFns } from "./HeadlineCard.vue?vue&type=template&id=47f1aff9&scoped=true&"
import script from "./HeadlineCard.vue?vue&type=script&lang=js&"
export * from "./HeadlineCard.vue?vue&type=script&lang=js&"
import style0 from "./HeadlineCard.vue?vue&type=style&index=0&id=47f1aff9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f1aff9",
  null
  
)

export default component.exports